module.exports = "<div style=\"width:100%;height:100%\" fxLayoutAlign=\"center center\">\n  <span style=\"font-size: 30px;color: rgb(211, 209, 216);\">{{'Coming Soon' | translate}}</span>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shelf/dropbox/dropbox.component.html
// module id = ./src/app/shelf/dropbox/dropbox.component.html
// module chunks = main